import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { AgControlComponent, AgControlComponentParams, noop } from './ag-control.component';
import { InputMaskComponent } from '../../components/input-mask/input-mask.component';

interface AgInputMaskComponentParams extends AgControlComponentParams {
  allowNegative?: boolean;

  currencySign?: string;
  placeholder?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, InputMaskComponent, AsyncPipe],
  template: `
    @if (formGroup$ | async) {
      <div [formGroup]="$any(formGroup$ | async)">
        @if (isReady$ | async) {
          <aux-input-mask
            class="w-full"
            [formControl]="formControl"
            maskType="money"
            [inputClassName]="
              hasError ? 'border-aux-red-dark !rounded ' + controlHeightClass : controlHeightClass
            "
            [placeholder]="placeholder"
            [allowNegativeNumbers]="allowNegative"
            [moneyPrefix]="formControl.value === null ? '' : (params.currencySign ?? '$')"
          />
        }
      </div>
    }
  `,
})
export class AgInputMaskComponent extends AgControlComponent {
  protected allowNegative = false;
  params!: AgInputMaskComponentParams;
  protected placeholder = '';

  agInit(params: AgInputMaskComponentParams): void {
    this.params = params;
    this.value = params.value;
    this.placeholder = params.placeholder ?? '';

    this.allowNegative = !!params.allowNegative;

    this.fieldName = params.colDef?.field;
    this.changeHandler = params.changeHandler ?? noop;
    this.updateView(params);
  }
}
